var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconErase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3185 0.219727V24.2197H0.318481V0.219727H24.3185Z",
    fill: "#FFE9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3185 19.2197L18.1796 19.2197",
    stroke: "#1D1B1B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5213 18.6711C10.7402 19.4521 9.47389 19.4521 8.69284 18.6711L5.4398 15.418C5.04928 15.0275 5.04928 14.3944 5.4398 14.0038L13.1028 6.34083C13.4933 5.9503 14.1265 5.9503 14.517 6.34083L18.4772 10.301C18.8677 10.6915 18.8677 11.3247 18.4772 11.7152L11.5213 18.6711Z",
    stroke: "#1D1B1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8099,
    y: 17.7964,
    width: 9.60049,
    height: 9.60049,
    rx: 2,
    transform: "rotate(-135 13.8099 17.7964)",
    fill: "#1D1B1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErase);
export default __webpack_public_path__ + "static/media/icon_erase.bcf119fd303da383f1a14e16a83c3d98.svg";
export { ForwardRef as ReactComponent };